import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { memo } from 'common/hocs/memo';
import { SeoProperties } from 'modules/model-json';

export type SeoTextProps = {
  seoProperties: SeoProperties | undefined;
  className?: string;
  style?: React.CSSProperties;
};

export const SeoText = memo<SeoTextProps>(({ seoProperties, className, ...props }) => {
  if (!seoProperties?.seotext) return null;

  return (
    <CategoryDescription
      className={cn(seoText, className)}
      {...props}
      dangerouslySetInnerHTML={{ __html: seoProperties.seotext }}
    />
  );
});

const CategoryDescription = styled.div`
  width: 100%;
  margin: 40px 0;
  background-color: var(--text-invert);
`;

const seoText = css`
  & {
    display: block;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-secondary);
  }

  & * {
    padding: 0;
    margin: 0;
  }

  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    margin-bottom: 8px;
    color: var(--text-secondary);
  }

  & h2 {
    font-weight: 600;
    font-size: 16px;
    line-height: 21px;
  }

  & h3 {
    margin-top: 16px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  }

  & p {
    margin-bottom: 9px;
  }

  & ul {
    margin-bottom: 12px;
    margin-left: 45px;
    list-style: disc;
  }

  & a {
    text-decoration: none;
    color: var(--control-accent);
  }

  & a:hover,
  & a:active {
    color: var(--control-hover-accent);
  }
`;
